import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// PWA: registra o service worker apenas em produção (build), sobre HTTPS.
// Em desenvolvimento não registra para não interferir no hot reload.
if (
  process.env.NODE_ENV === "production" &&
  "serviceWorker" in navigator &&
  (window.location.protocol === "https:" || window.location.hostname === "localhost")
) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js", { updateViaCache: "none" })
      .then((reg) => {
        setInterval(() => reg.update().catch(() => {}), 60 * 60 * 1000);
        reg.addEventListener("updatefound", () => {
          const nw = reg.installing;
          if (!nw) return;
          nw.addEventListener("statechange", () => {
            if (nw.state === "installed" && navigator.serviceWorker.controller) {
              nw.postMessage("SKIP_WAITING"); // ativa a nova versão no próximo controllerchange
            }
          });
        });
      })
      .catch(() => {});
    let reloaded = false;
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (reloaded) return;
      // Portal do Cliente: adia o reload enquanto houver interacao em andamento (login/PIX).
      if (window.__PORTAL_BUSY__) {
        const t = setInterval(() => {
          if (!window.__PORTAL_BUSY__) { clearInterval(t); reloaded = true; window.location.reload(); }
        }, 1500);
        return;
      }
      reloaded = true;
      window.location.reload(); // recarrega uma vez para aplicar o novo build
    });
  });
}

